// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2USTZ","title":"Info_title__3pRFa","selects":"Info_selects__18KB8","requiredAsterisk":"Info_requiredAsterisk__1Lx3h"};